import { ConvexMessage } from "../../types/message";
import { AttachmentType } from "../../types/message";
import '../../Styles/Layout/MessageAttachments.css'
import '../../Styles/Layout/FileCard.css'
import { MessageImage, MessageDocument } from "../../types/message";
import { useAttachmentContext } from "../../contexts/AttachmentContext";
import { getFileTypeLabel } from "./FileCard";
import { FileCardThumbnail } from "./FileCardThumbnail";
import { ImageFileCard } from "../Message/ImageFileCard";
interface MessageAttachmentsProps {
  message: ConvexMessage;
  handleResourceClick: (title: string, messageId: string) => void;
}

interface Attachment {
    title: string;
    url: string | null;
    type: AttachmentType;
}

export const MessageAttachments = ({ message, handleResourceClick }: MessageAttachmentsProps) => {
    const { handleImageClick } = useAttachmentContext();
    const documents: MessageDocument[] = message.textAttachments || [];
    const images: MessageImage[] = message.images || [];
    const hasAttachments = (images.length > 0 || documents.length > 0);

    const handleAttachmentClick = (attachment: Attachment) => {
        if(attachment.url && attachment.type?.startsWith('image')){
            handleImageClick(attachment.url, attachment.title);
        } else {
            handleResourceClick(attachment.title, message._id);
        }
    }

    if(!hasAttachments){
        return null;
    }

    return (
        <div className="message-attachments">
            {images.length > 0 && (
                <div className="message-attachments-list images-row">
                    {images.map((img) => (
                        <ImageFileCard key={img.title} image={img} onClick={() => handleAttachmentClick({
                            title: img.title,
                            url: img.url,
                            type: img.media_type
                        })} />
                    ))}
                </div>
            )}
            {documents.length > 0 && (
                <div className="message-attachments-list documents-row">
                    {documents.map((doc) => (
                        <button
                            type="button"
                            key={doc.title}
                            className="file-card file-card-in-message"
                            aria-label={`${doc.title}, ${getFileTypeLabel(doc.title, doc.type)}`}
                            onClick={() => handleAttachmentClick({
                                title: doc.title,
                                url: doc.url,
                                type: doc.type
                            })}
                        >
                            <FileCardThumbnail
                                type={doc.type}
                                content={doc.content}
                                url={doc.url}
                            />
                            <span className="file-card-type">
                                {getFileTypeLabel(doc.title, doc.type)}
                            </span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}
